// extracted by mini-css-extract-plugin
module.exports = {"Banner":"WelcomeBanner_Banner__31BZD","Text":"WelcomeBanner_Text__3H50K","Title":"WelcomeBanner_Title__1prFF","Button":"WelcomeBanner_Button__1OtVD"};